import { nonEmptyArray, array } from "fp-ts"

export const isSingle = <T>(arr: T[]): arr is nonEmptyArray.NonEmptyArray<T> =>
  array.size(arr) === 1

export const isMultiple = <T>(arr: T[]): arr is nonEmptyArray.NonEmptyArray<T> =>
  array.size(arr) > 1
